export default "__VITE_ASSET__953cdd7b__"